import React, { useState, useEffect } from 'react'
import { Button, Col, Container, Row, Form, Spinner } from 'react-bootstrap'
import { CustomBorderDropDown, CustomBorderDropDown2, CustomBorderDropDowndo } from '../DropDown/DropDown';
import { CustomInputBorder2 } from '../Input/Input';
import TableComponentPagepay from '../Table/TablePayment';
import MultiSelect from '../../MultiSelect/MultiSelect';
import axios from 'axios';
import TableComponent from '../Table/Table';
import Select from 'react-select'
import ReactExport from "react-data-export";
import { CSVLink, CSVDownload } from "react-csv";
import moment from 'moment';
function Download(props) {

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


  return (
    <>
      {
        props.dataType == 0 ? (
          <ExcelFile hideElement={true} filename="Data" fileExtension={props.dataType == 0 ? "xlsx" : "csv"}>
            <ExcelSheet data={props.data} name="Data">
              {
                props.scolumns.filter(d => {
                  return d.active == true
                }).map(column => {
                  return (
                    <ExcelColumn label={column.name} value={column.key} />
                  )
                })
              }
            </ExcelSheet>
          </ExcelFile>
        ) : (
          <>
            <CSVDownload data={props.csvdata} target="_blank" />;
          </>
        )
      }
    </>
  );
}
function PaymentHitory() {

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id", // accessor is the "key" in the data
      },
      {
        Header: "Currency",
        accessor: "currency",
      },
      {
        Header: "Affiliate ID",
        accessor: "affiliateid",
      },
      {
        Header: "Username",
        accessor: "username",
      },
      {
        Header: "Period",
        accessor: "period",
      },
      {
        Header: "Commission",
        accessor: "commission",
      },
      {
        Header: "Carry Over",
        accessor: "carryover",
      },
      {
        Header: "Bonus Amount",
        accessor: "bonus",
      },
      {
        Header: "Profit",
        accessor: "profit",
      },
      {
        Header: "Hold",
        accessor: "hold",
      },
      {
        Header: "Paid",
        accessor: "paid"
      },
      {
        Header: "Payment Date",
        accessor: "paymentdate",
      },
      {
        Header: "Available Withdraw",
        accessor: "availablewithdraw",
      },
    ],
    []
  );
  const [historyPayment, setHistoryPayment] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [PaymentPages, setPaymentPages] = useState(1);
  const [ltComGrp, setLtComGrp] = useState([])
  const [ltAffGrp, setLtAffGrp] = useState([])
  const [loadingPaymentReport, setLoadingPaymentReport] = useState(false)
  const [ExportColumns, setExportColumns] = useState([
    {
      Header: "ID",
      accessor: "id", // accessor is the "key" in the data
    },
    {
      Header: "Currency",
      accessor: "currency",
    },
    {
      Header: "Affiliate ID",
      accessor: "affiliateid",
    },
    {
      Header: "Username",
      accessor: "username",
    },
    {
      Header: "Period",
      accessor: "period",
    },
    {
      Header: "Commission",
      accessor: "commission",
    },
    {
      Header: "Carry Over",
      accessor: "carryover",
    },
    {
      Header: "Bonus Amount",
      accessor: "bonus",
    },
    {
      Header: "Profit",
      accessor: "profit",
    },
    {
      Header: "Hold",
      accessor: "hold",
    },
    {
      Header: "Paid",
      accessor: "paid",
    },
    {
      Header: "Payment Date",
      accessor: "paymentdate",
    },
    {
      Header: "Available Withdraw",
      accessor: "availablewithdraw",
    },
  ])
  const [csvdata, setCsvData] = useState([]);
  const [extype, setExtype] = useState("");
  const [downloadable, setDownloadable] = useState(false);
  const [loading, setLoading] = useState(false)
  const [historyPaymentFilter, setHistoryPaymentFilter] = useState({
    filters: {
      period: [],
      affiliategroup: "",
      commissiongroup: "",
      affiliateid: ""
    }
  })
  const [dateTimeRange, setDateTimeRange] = useState({
    startDate: '',
    endDate: ''
  });

  const handleSelectionCommissionChange = (selectedItems) => {
    setHistoryPaymentFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, commissiongroup: selectedItems } }))
  };
  const handleSelectionaffiliateChange = (selectedItems) => {
    setHistoryPaymentFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, affiliategroup: selectedItems } }))
  };
  const getPaymentHistory = async () => {
    setLoadingPaymentReport(true)
    const response = await axios.post(window.__CFG.API + "payments/GetPaymentsHistory?page=" + currentPage, historyPaymentFilter, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    setLoadingPaymentReport(false)
    if (response.data.Error == null) {
      setHistoryPayment(response.data.Result.Data);
      setPaymentPages(response.data.Pages)
    }
    else {
      setHistoryPayment([])
    }
  }
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    if (currentPage !== 1)
      getPaymentHistory()
  }, [currentPage])
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSelectPeriodChange = (e) => {
    const selectedValue = e.value;
    const today = new Date();
    let startDate = '';
    let endDate = '';

    switch (selectedValue) {
      case 'today':
        startDate = formatDate(new Date(today.setHours(0, 0, 0, 0)));
        endDate = formatDate(new Date(today.setHours(23, 59, 59, 999)));
        break;
      case 'yesterday':
        const yesterday = new Date(today.setDate(today.getDate() - 1));
        startDate = formatDate(new Date(yesterday.setHours(0, 0, 0, 0)));
        endDate = formatDate(new Date(yesterday.setHours(23, 59, 59, 999)));
        break;
      case 'currentmonth':
        startDate = formatDate(new Date(today.getFullYear(), today.getMonth(), 1));
        endDate = moment().endOf("month").format("YYYY-MM-DD");
        break;
      case 'lastmonth':
        startDate = formatDate(new Date(today.getFullYear(), today.getMonth() - 1, 1));
        endDate = formatDate(new Date(today.getFullYear(), today.getMonth(), 0));
        break;
      case 'currentyear':
        startDate = formatDate(new Date(today.getFullYear(), 0, 1));
        endDate = moment().endOf("year").format("YYYY-MM-DD");
        break;
      case 'lastyear':
        startDate = formatDate(new Date(today.getFullYear() - 1, 0, 1));
        endDate = formatDate(new Date(today.getFullYear() - 1, 11, 31));
        break;
      default:
        startDate = '';
        endDate = '';
    }
    setDateTimeRange({ startDate, endDate });

  }
  const setTodayAsDefault = () => {
    const today = new Date();
    const startDate = formatDate(new Date(today.setHours(0, 0, 0, 0)));
    const endDate = formatDate(new Date(today.setHours(23, 59, 59, 999)));
    setDateTimeRange({ startDate, endDate });
  };
  useEffect(() => {
    setTodayAsDefault();
  }, []);

  useEffect(() => {
    var period = [];
    var paymentHistory = Object.assign({}, historyPaymentFilter)
    if (dateTimeRange.startDate != "" && dateTimeRange.endDate != "") {
      period.push(dateTimeRange.startDate)
      period.push(dateTimeRange.endDate)
    }
    paymentHistory.filters.period = period;
    setHistoryPaymentFilter(paymentHistory);
  }, [dateTimeRange]);

  const getListAffliateGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllAffiliateGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtAffGrp(response.data.Result)
    }
  }
  const getListCommissionGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllCommissionGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtComGrp(response.data.Result)
    }
  }
  useEffect(() => { getListAffliateGrp(); getListCommissionGrp() }, [])
  const optionsCurrency = [{ label: "USD", value: 1 }]
  const optionsPeriods = [{ label: "Today", value: "today" }, { label: "Yesterday", value: "yesterday" }, { label: "Current month", value: "currentmonth" }, { label: "Last month", value: "lastmonth" }, { label: "Current year", value: "currentyear" }, { label: "Last year", value: "lastyear" }, { label: "Custom", value: "custom" },]
  const selectedCurrencyValue = optionsCurrency.find(option => option.value === 1)
  const optionsExport = [{ label: "CSV", value: 1 }]
  const selectedExportValue = optionsExport.find(options => options.value === 1)
  const selectKeys = (arr, keys) => {
    return arr.map(item =>
      keys.reduce((acc, key) => {
        if (item.hasOwnProperty(key)) {
          acc[key] = item[key];
        }
        return acc;
      }, {})
    );
  };
  const ExportData = async (type) => {
    setLoading(true);

    const response = await axios.post(window.__CFG.API + "payments/GetPaymentsHistory?all=true", historyPaymentFilter, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    });

    setLoading(false);

    setExtype(type)

    if (response.data.Error == null) {
      let mcolumns = [];

      for (var k = 0; k < ExportColumns.length; k++) {
        var column = ExportColumns[k];

        mcolumns.push(column.accessor)

      }

      setCsvData(selectKeys(response.data.Result.Data, mcolumns))

      setDownloadable(true);

      setTimeout(() => {
        setDownloadable(false);
      }, 500)
    }
  }
  return (
    <>
      <Container>
        <Row>
          <Col>
            <h4 className="text-start mt-5">Payment History</h4>

            <Row style={{ paddingTop: 20, paddingBottom: 10 }} className="justify-content-between  mt-2  me-auto w-100">

              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Period</label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={optionsPeriods} onChange={handleSelectPeriodChange} defaultValue={{ label: "Today", value: "today" }} />
                  </div>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-between  mt-2  me-auto w-100">

              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label> Currency </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={optionsCurrency} value={selectedCurrencyValue} />

                  </div>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-between  mt-2  me-auto w-100">

              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label> commission group </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <MultiSelect options={ltComGrp} onSelectionChange={handleSelectionCommissionChange} />
                  </div>
                </div>
              </Col>
            </Row>
            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-between  mt-2 me-auto w-100">

              <Col lg={6} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label> affiliate group </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <MultiSelect options={ltAffGrp} onSelectionChange={handleSelectionaffiliateChange} />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-between  mt-2  me-auto w-100">
              <Col lg={6} md={4} sm={5}>
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label> Affiliate ID </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type='text' value={historyPaymentFilter.filters.affiliateid} onChange={e => { setHistoryPaymentFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, affiliateid: e.target.value } })) }} />
                  </div>
                </div>
              </Col>

            </Row>

            <Row className="justify-content-between  mt-2  me-auto w-100" style={{ paddingBottom: 20 }} >
              <Col lg={6} md={4} sm={5} className=" pt-2">
                <div className="form-cre-grp-fl-wp">
                  <div className="form-cre-grp-fl-wp-lb">
                  </div>
                  <div className="form-cre-grp-fl-wp-in  md-se-btn">
                    <Button disabled={loadingPaymentReport} onClick={getPaymentHistory} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                      {loadingPaymentReport ? (<> <Spinner size="sm"></Spinner></>) : (<>
                        Generate report

                      </>)}
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
            <div
              style={{
                borderBottom: "1px dashed black",
                marginTop: "20px",
                width: "100%",
              }}
            ></div>

            <Row className="mt-4 me-4 w-100">
              <div className='export-aff'>
                <div style={{ flex: 1 }} className="dashboard-select-periode">
                  <Select options={optionsExport} placeholder="export type" value={selectedExportValue} />
                </div>
                <div style={{ marginLeft: 10 }} className='aff-exp-btn'>
                  <button disabled={loading} onClick={() => ExportData(1)}>
                  {!loading ? (<>Export</>) : (<><Spinner size="sm"></Spinner> </>)}
                  </button>
                </div>
              </div>
            </Row>
            <Row className="mt-2 mb-2">
              <div className="aff-dash-summary-table full-payment-report-table">

                <TableComponent columns={columns} data={historyPayment} Pages={PaymentPages} currentPage={currentPage} onPageChange={handlePageChange} loading={loadingPaymentReport} />
              </div>
            </Row>
          </Col>

          {
            downloadable ? (
              <Download scolumns={ExportColumns} dataType={extype} csvdata={csvdata} data={historyPayment} />
            ) : (
              <></>
            )
          }
        </Row>
      </Container>
    </>
  )
}

export default PaymentHitory